"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _datePicker = _interopRequireDefault(require("@insided/deprecated-preact-components/date-picker"));

var _AnalyticsDateFormatter = _interopRequireDefault(require("./AnalyticsDateFormatter"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _excluded = ["startDate", "endDate", "isDropdownOpen", "toggleDropdown", "onReset", "onCustomDateChange", "onPresetDateChange", "onChange", "items", "selectedDate", "selectedPresetId", "isLoading", "showMonths", "minDate"];

var DashboardDateRangeFilter = function DashboardDateRangeFilter(_ref) {
  var startDate = _ref.startDate,
      endDate = _ref.endDate,
      isDropdownOpen = _ref.isDropdownOpen,
      toggleDropdown = _ref.toggleDropdown,
      onReset = _ref.onReset,
      onCustomDateChange = _ref.onCustomDateChange,
      onPresetDateChange = _ref.onPresetDateChange,
      onChange = _ref.onChange,
      items = _ref.items,
      selectedDate = _ref.selectedDate,
      selectedPresetId = _ref.selectedPresetId,
      isLoading = _ref.isLoading,
      _ref$showMonths = _ref.showMonths,
      showMonths = _ref$showMonths === void 0 ? 1 : _ref$showMonths,
      minDate = _ref.minDate,
      otherProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var today = new Date();
  var applyButtonProps = otherProps['data-track-type'] ? {
    'data-track-type': otherProps['data-track-type'],
    'data-element-name': 'Date range apply button'
  } : {};
  var cancelButtonProps = otherProps['data-track-type'] ? {
    'data-track-type': otherProps['data-track-type'],
    'data-element-name': 'Date range cancel button'
  } : {};
  return (0, _preact.h)("div", {
    className: "filter-option filter-option-date"
  }, (0, _preact.h)(_Button.default, (0, _extends2.default)({
    disabled: isLoading,
    title: (0, _preact.h)(DateRangeFilterTitle, {
      startDate: startDate,
      endDate: endDate,
      isDropdownOpen: isDropdownOpen
    }),
    size: "medium",
    className: "date-range-open-button filter-option-button ".concat(isDropdownOpen ? 'dropdown-open' : '', " "),
    onClick: function onClick() {
      return toggleDropdown(!isDropdownOpen);
    }
  }, otherProps)), isDropdownOpen && (0, _preact.h)("div", {
    className: "overview__filters-box-container"
  }, (0, _preact.h)("div", {
    className: "overview__filters-box filters-box-date-range"
  }, (0, _preact.h)("div", {
    className: "overview__filters-box-content filters-box-content-date-range"
  }, (0, _preact.h)("div", {
    className: "filter-preset-date-range"
  }, items.map(function (item) {
    return (0, _preact.h)(PresetDateTooltip, {
      key: item.id,
      item: item,
      onPresetDateChange: onPresetDateChange,
      selectedPresetId: selectedPresetId
    });
  })), (0, _preact.h)("div", {
    className: "custom-date-range-wrapper"
  }, (0, _preact.h)("div", null, (0, _preact.h)(_datePicker.default, {
    allowPastDates: true,
    allowRange: true,
    value: startDate,
    maxDate: today,
    minDate: minDate ? minDate.toISOString().split('T')[0] : undefined,
    defaultDateRange: selectedDate !== null && selectedDate !== void 0 && selectedDate.startDate && selectedDate !== null && selectedDate !== void 0 && selectedDate.endDate ? [new Date(selectedDate.startDate), new Date(selectedDate.endDate)] : undefined,
    disableInput: true,
    classes: ['date-picker-start-date'],
    onChange: function onChange(dates) {
      return onCustomDateChange(dates);
    },
    showMonths: showMonths
  })))), (0, _preact.h)("div", {
    className: "preset-date-range-action-buttons"
  }, (0, _preact.h)("hr", null), (0, _preact.h)("div", {
    className: "overview__filters-box-buttons"
  }, (0, _preact.h)(_Button.default, (0, _extends2.default)({
    size: "small",
    variant: "brand",
    title: "Apply",
    onClick: function onClick() {
      if (selectedDate.endDate === undefined) onCustomDateChange([selectedDate.startDate, selectedDate.startDate]);
      onChange();
    }
  }, applyButtonProps)), (0, _preact.h)(_Button.default, (0, _extends2.default)({
    size: "small",
    title: "Cancel",
    onClick: onReset
  }, cancelButtonProps)))))));
};

var PresetDateTooltip = function PresetDateTooltip(_ref2) {
  var item = _ref2.item,
      selectedPresetId = _ref2.selectedPresetId,
      onPresetDateChange = _ref2.onPresetDateChange;

  var formattedStartDate = _AnalyticsDateFormatter.default.displayFormattedDateInFilter(new Date(item.startDate));

  var formattedEndDate = _AnalyticsDateFormatter.default.displayFormattedDateInFilter(new Date(item.endDate));

  var isSameDate = _AnalyticsDateFormatter.default.isSameDay(formattedStartDate, formattedEndDate);

  return (0, _preact.h)(_Tooltip.default, {
    position: "center",
    trigger: (0, _preact.h)("button", {
      key: item.id,
      className: "overview__filters-box-content preset-date-range-option",
      onClick: function onClick() {
        return onPresetDateChange(item);
      },
      tabIndex: 0
    }, (0, _preact.h)("div", {
      className: "".concat(selectedPresetId && item.id === selectedPresetId ? 'selected-date-range' : '')
    }, item.label), selectedPresetId && item.id === selectedPresetId && (0, _preact.h)("div", {
      className: "selected-date-range icon-check-wrapper"
    }, (0, _preact.h)(_assets.default, {
      icon: "check",
      customClass: "icon-check"
    }))),
    customClasses: "preset-daterange-tooltip",
    tooltipMessage: isSameDate ? "".concat(formattedStartDate) : "".concat(formattedStartDate, " - ").concat(formattedEndDate)
  });
};

var DateRangeFilterTitle = function DateRangeFilterTitle(_ref3) {
  var startDate = _ref3.startDate,
      endDate = _ref3.endDate,
      isDropdownOpen = _ref3.isDropdownOpen;

  var formattedStartDate = _AnalyticsDateFormatter.default.displayFormattedDateInFilter(startDate);

  var formattedEndDate = _AnalyticsDateFormatter.default.displayFormattedDateInFilter(endDate);

  var isSameDate = _AnalyticsDateFormatter.default.isSameDay(formattedStartDate, formattedEndDate);

  return (0, _preact.h)("div", null, (0, _preact.h)("span", {
    className: "dropdown-placeholder-text ".concat(isDropdownOpen ? 'filter-dropdown-open' : '')
  }, "Date"), (0, _preact.h)("span", {
    className: "dropdown-selected-placeholder date-range ".concat(isDropdownOpen ? 'filter-dropdown-open' : '')
  }, ' ', isSameDate ? "".concat(formattedStartDate) : "".concat(formattedStartDate, " - ").concat(formattedEndDate)));
};

var _default = DashboardDateRangeFilter;
exports.default = _default;